module.exports = __webpack_public_path__ + "static/media/1.dfc08484.jpg";